module.exports = __webpack_public_path__ + "static/media/CompanyKitchenGradientHeader.5272f8fd.png";